import React from 'react';

import { DateTime } from 'luxon';
import { useObservedFailureWidgetQuery } from 'generated/graphql';



export interface IObservation {
  text: string;
  createdTimestamp: DateTime;
  technicianFullName: string;
}

export interface IData {
  observation: IObservation | null;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useObservedFailureWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.tier1ReturnAuthorization;
      const data: IData = {
        observation: returnAuthorization?.observation ? {
          text: returnAuthorization.observation.reasonText ?? '-',
          createdTimestamp: DateTime.fromISO(returnAuthorization.observation.createdTimestamp),
          technicianFullName: returnAuthorization.observation?.createdBy.fullName ?? '-'
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
